module.exports = __webpack_public_path__ + "img/testimonial-divider.34b83353.svg";